import Dialog from "@mui/material/Dialog";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const is_small_medium_screen = () => {
  if (window.innerWidth < 767) {
    return true;
  } else {
    return false;
  }
};

export default function CustomPopoverNew({
  isOpenPop,
  is_hide_icon,
  isClosePop = () => {},
  title,
  componentToPassDown,
  heigh,
  width,
}) {
  const handleClose = () => {
    isClosePop(false);
  };

  return (
    <Dialog
      maxWidth="md"
      sx={{
        "@media (max-width: 768px)": {
          ml: 0,
        },
      }}
      open={isOpenPop}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          backgroundColor: "#ffffff",
          color: "black",
          boxShadow: "none",
          boxShadow: "0px 3px 5px rgba(0,0,0,0.4)",
          width: is_small_medium_screen() ? "100%" : width ? width : "950px",
          minHeight: heigh ? heigh : "auto",
        },
      }}
    >
      <Box>
        <div className="custom-modal mt-2 px-4">
          <div>
            <Typography variant="h5" component="h2" sx={{ color: "#000080" }}>
              {title}
            </Typography>
          </div>
          {!is_hide_icon && (
            <div>
              <IconButton onClick={handleClose} className="icon-button-modal">
                <CloseIcon />
              </IconButton>
            </div>
          )}
        </div>
        <div>{componentToPassDown}</div>
      </Box>
    </Dialog>
  );
}
